import React from 'react';
import './Checkbox.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, children }) => {
  return (
    <div className="flex items-start gap-4 w-full">
      <label className="container-checkbox shrink-0 mt-0.5">
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
        />
        <div className="checkmark" />
      </label>
      {children && (
        <div className="flex-1 mt-1 text-sm text-grey-700 dark:text-text-secondary cursor-pointer" onClick={() => onChange({ target: { checked: !checked } } as React.ChangeEvent<HTMLInputElement>)}>
          {children}
        </div>
      )}
    </div>
  );
};
